import { Link } from 'react-router-dom';
import { useSettings } from '@/store/useSettings';
import { Facebook, Instagram, Twitter } from 'lucide-react';
import { themeConfig } from '@/config/theme.config';

export function Footer() {
    const { shopInfo } = useSettings();

    return (
        <footer className="w-full border-t bg-background">
            <div className="container px-4 py-10 md:px-6 mx-auto max-w-[1280px]">
                <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
                    <div className="space-y-3">
                        <Link to="/" className="flex items-center space-x-2 font-bold text-xl">
                            {shopInfo.logo_url && <img src={shopInfo.logo_url} alt="Logo" className="h-6 w-6" />}
                            <span>{shopInfo.shop_name || themeConfig.defaults.shopName}</span>
                        </Link>
                        <p className="text-sm text-muted-foreground">
                            Your one-stop shop for everything. Quality products, fast delivery.
                        </p>
                        <div className="flex space-x-4">
                            {/* Social Placeholders */}
                            <Link to="#" className="text-muted-foreground hover:text-foreground"><Facebook className="h-5 w-5" /></Link>
                            <Link to="#" className="text-muted-foreground hover:text-foreground"><Instagram className="h-5 w-5" /></Link>
                            <Link to="#" className="text-muted-foreground hover:text-foreground"><Twitter className="h-5 w-5" /></Link>
                        </div>
                    </div>
                    <div className="space-y-3">
                        <h4 className="text-base font-semibold">Quick Links</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/products" className="text-muted-foreground hover:text-foreground">All Products</Link></li>
                            <li><Link to="/categories" className="text-muted-foreground hover:text-foreground">Categories</Link></li>
                            <li><Link to="/track-order" className="text-muted-foreground hover:text-foreground">Track Order</Link></li>
                        </ul>
                    </div>
                    <div className="space-y-3">
                        <h4 className="text-base font-semibold">Support</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/contact" className="text-muted-foreground hover:text-foreground">Contact Us</Link></li>
                            <li><Link to="/faq" className="text-muted-foreground hover:text-foreground">FAQs</Link></li>
                            <li><Link to="/terms" className="text-muted-foreground hover:text-foreground">Terms of Service</Link></li>
                            <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground">Privacy Policy</Link></li>
                        </ul>
                    </div>
                    <div className="space-y-3">
                        <h4 className="text-base font-semibold">Contact</h4>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            {shopInfo.address && <li>{shopInfo.address}</li>}
                            {shopInfo.support_phone && <li>Phone: {shopInfo.support_phone}</li>}
                            {shopInfo.support_email && <li>Email: {shopInfo.support_email}</li>}
                        </ul>
                    </div>
                </div>
                <div className="mt-10 border-t pt-6 text-center text-sm text-muted-foreground">
                    <p>&copy; {new Date().getFullYear()} {shopInfo.shop_name || 'Store Name'}. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
